import { userService } from "@/api/user.service.js";

export const state = {
  selectedEmailAddress: ""
}

export const actions = {
  setSelectedEmailAddress({ commit }, emailAddress) {
    commit("setSelectedEmailAddress", emailAddress)
  },
  sendSupportEmail({ commit, dispatch }, email){
    userService.sendSupportEmail(email)
      .then(() => {
        commit("reset");
        dispatch("notification/success", 'Email sent.', { root: true });
      });
  }
};

export const mutations = {
  setSelectedEmailAddress(state, emailAddress) {
    state.selectedEmailAddress = emailAddress;
  },
  reset(state){
    state.selectedEmailAddress = "";
  }
};
